export function createUsNumberFormat(number) {
  return number.toLocaleString('en-US');
}
